module.exports = __webpack_public_path__ + "static/safarijacketset-f2074fdb19c70602a445471ff4d64e36.jpeg";